import Vue from 'vue';
import Vuex, { Plugin } from 'vuex';
import VuexPersist from 'vuex-persist';
import { entity, IEntityState } from '@signing-page/entity/store/entity.store';
import { document, IDocumentState } from '@signing-page/documents/store/document.store';
import { tracking } from '@signing-page/tracking/store/tracking.store';
import { alert } from '@signing-page/alert/store/alert.store';
import { chat } from '@signing-page/chat/store/chat.store';
import { session } from '@signing-page/session/store/session.store';
import { signing } from '@signing-page/signing/store/signing.store';
import { mutations } from '@signing-page/store/mutations';
import { actions } from '@signing-page/store/actions';
import { VuexPersistHelper } from '@signing-page/session/helpers/vuex-persist.helper';
import {
  IIntegrationState,
  integrations,
} from '@signing-page/integrations/store/integrations.store';

Vue.use(Vuex);

export interface IRootState {
  authId: string;
  documentId: string;
  recipientId: string;
  userId: string;
  videoReminderId?: string;
  isPreview: boolean;
  document?: IDocumentState;
  entity?: IEntityState;
  integrations?: IIntegrationState;
  previewExpired: boolean;
}

export const state: IRootState = {
  authId: null,
  documentId: null,
  recipientId: null,
  userId: null,
  isPreview: false,
  previewExpired: false,
};

const storageKey: string = VuexPersistHelper.getSessionKey(window.location.href);
const vuexLocalStorage = new VuexPersist({
  key: storageKey,
  storage: window.localStorage,
  reducer: (state: any) => ({
    session: {
      token: state.session.token,
    },
    recipientId: state.recipientId,
    chat: {
      isOpen: state.chat.isOpen,
    },
  }),
});

const previewKey: string = VuexPersistHelper.getPreviewKey(window.location.href);
const vuexPreviewLocalStorage = new VuexPersist({
  key: previewKey,
  storage: window.sessionStorage,
  reducer: (state: any) => ({
    session: {
      token: state.session.token,
    },
  }),
});
const plugins: Plugin<IRootState>[] = [];
if (storageKey) {
  plugins.push(vuexLocalStorage.plugin);
}
if (previewKey) {
  plugins.push(vuexPreviewLocalStorage.plugin);
}

export default new Vuex.Store<IRootState>({
  state,
  actions,
  mutations,
  modules: {
    alert,
    chat,
    document,
    entity,
    tracking,
    signing,
    session,
    integrations,
  },
  plugins,
});
